export const KYC_IDV_DOCS_EVENTS = {
  VIEW_KYC_IDV_DOCS_TYPE_FORM_ON_READY:
    'external_loaded_kyc_idv_docs_requested_typeform',
  SELECT_KYC_IDV_DOCS_TYPE_FORM_ON_SUBMIT:
    'external_select_kyc_idv_docs_typeform',
  VIEW_KYC_IN_REVIEW_IDV_DOCS_PAGE: 'view_kyc_in_review_idv_docs_requested',
} as const;
